import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

export type BreadcrumbItem = {
    label: string
    href?: string
}

interface BreadcrumbProps {
    items: Array<BreadcrumbItem>
    className?: string
}

const Breadcrumb: FC<BreadcrumbProps> = ({ items, className }): ReactNode => {
    return (
        <nav aria-label='Breadcrumb' className={className}>
            <ol className='flex flex-wrap items-center gap-x-2 gap-y-1 font-mono text-caption text-muted-foreground'>
                {items.map((item, index) => {
                    const isLast = index === items.length - 1

                    return (
                        <li key={`${item.label}-${index}`} className='flex min-w-0 items-center gap-2'>
                            {index > 0 && <span aria-hidden='true' className='text-border-strong'>/</span>}

                            {item.href && !isLast ? (
                                <Link href={item.href} className='link-underline hover:text-foreground'>
                                    {item.label}
                                </Link>
                            ) : (
                                <span
                                    aria-current={isLast ? 'page' : undefined}
                                    className={cn('truncate', isLast && 'max-w-[22ch] text-foreground sm:max-w-[40ch]')}
                                >
                                    {item.label}
                                </span>
                            )}
                        </li>
                    )
                })}
            </ol>
        </nav>
    )
}

export default Breadcrumb
